import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) =>
	({
		label: {
			whiteSpace: "nowrap",

		},
		minute: {
			textAlign: "left"
		},
		field: {
			minWidth: 55
		}
	} satisfies Record<string, CSSObject>);
